import { useState } from "react";
import ICONS from "../../../../assets/Icons";
import accountNameStandardised from "../../../../utils/accountNamestandardised";
import TextInputField from "../../CommonInputFields/TextInputField";
import { GlobalConfiguration } from "../../../../utils/configurationProvider";

const PanDetails = ({
  verifiedPan,
  verifyPANisLoading,
  panNumber,
  handlePanChange,
  panDetails,
  legalName,
  previewMode = false,
  type,
}) => {
  const [isFocused, setIsFocused] = useState(false);
  const computeVariant = (value, focused) => {
    const length = (value ?? "").trim().length;

    if (length === 0) return focused ? "typing" : "default";
    // if (length < GlobalConfiguration.panLength && !verifiedPan) {
    //   return focused ? "typing" : "default";
    // }

    if (verifiedPan) return "verified";
    if (!verifiedPan && !verifyPANisLoading) {
      return length === GlobalConfiguration.panLength
        ? "error"
        : focused
          ? "typing"
          : "default";
    }

    return focused
      ? "typing"
      : length === GlobalConfiguration.panLength
        ? "error"
        : "default";
  };
  if (previewMode) {
    return (
      <div className="flex flex-col bg-primary-card rounded-border-radius-md gap-gap-button-l p-padding-md">
        <div className="text-text-primary font-semibold text-md">
          PAN Details
        </div>

        <div className="flex flex-col gap-gap-sm">
          <div className="flex flex-col gap-gap-xs">
            <div className="truncate capitalize font-normal text-text-primary text-md">
              {panNumber}
            </div>
            <div className="text-xs text-text-secondary">PAN number</div>
          </div>

          <div className="bg-primary-bg h-[var(--border)] opacity-base-opacity my-margin-xs"></div>

          <div className="flex flex-col gap-gap-xs">
            <div className="text-text-primary capitalize text-md">
              {accountNameStandardised(legalName?.toLowerCase())}
            </div>
            <div className="text-xs text-text-secondary">Legal name</div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div
      className={`w-width-full rounded-border-radius-md relative z-z-index-header ${verifiedPan && panNumber && type === "switch_account" ? "opacity-light-opacity" : "opacity-base-opacity"}`}
    >
      <div className="w-width-full rounded-border-radius-md relative z-z-index-header">
        <div
          className={`absolute w-width-full py-padding-md bottom-bottom-base transition-all duration-animation-fast ease-in-out transform ${
            (!verifyPANisLoading && verifiedPan) || verifiedPan === false
              ? "rounded-b-none"
              : "rounded-b-border-radius-md"
          }`}
          style={{
            backgroundColor:
              verifiedPan && !verifyPANisLoading
                ? "var(--positive-card)"
                : verifiedPan === false && !verifyPANisLoading
                  ? "var(--negative-card)"
                  : "transparent",
          }}
        ></div>
        <div className="w-width-full flex flex-col gap-gap-md p-padding-md bg-primary-card rounded-border-radius-md relative">
          <div className="font-semibold text-md text-text-primary">
            PAN Details
          </div>
          <div>
            <TextInputField
              variant={computeVariant(panNumber, isFocused)}
              placeholder="PAN number"
              bgColor="var(--primary-card)"
              fgColor="var(--text-primary)"
              value={panNumber}
              onInput={(e) => {
                handlePanChange(e);
              }}
              onFocus={(e) => setIsFocused(true)}
              onBlur={(e) => setIsFocused(false)}
              isFullWidth={true}
              adornment={
                verifyPANisLoading
                  ? "https://q2pay.in/new_assets/gifs/inputloader_white.gif"
                  : !verifiedPan &&
                      panNumber.length === GlobalConfiguration.panLength
                    ? ICONS.ERROR_WITH_WHITE_OUTLINED_CIRCLE
                    : undefined
              }
              isDisabled={type === "switch_account"}
            />
          </div>
        </div>
      </div>
      <div
        className={`transition-transform duration-animation-fast ease-in-out transform ${
          (!verifyPANisLoading && verifiedPan) || verifiedPan === false
            ? "translate-y-0 opacity-base-opacity"
            : "-translate-y-full opacity-opacity-none"
        }`}
      >
        {!verifyPANisLoading && verifiedPan ? (
          <div
            className={`flex justify-between items-center px-padding-md py-padding-sm rounded-b-border-radius-md bg-positive-card`}
          >
            <div className="flex justify-between items-start whitespace-nowrap overflow-hidden text-ellipsis text-text-primary">
              <img
                className="w-icon-md h-icon-md mr-margin-sm mt-margin-xs"
                src={ICONS?.VERIFIED_WITH_WHITE_CIRCLE_GREEN}
                alt="check"
              />
              <div className="flex flex-col gap-gap-xs">
                <div className="w-auto overflow-hidden text-ellipsis capitalize text-text-primary break-words whitespace-normal">
                  {panDetails?.full_name.toLowerCase()}
                </div>
                <div className="text-text-secondary text-left text-xs font-normal">
                  Legal name
                </div>
              </div>
            </div>
          </div>
        ) : verifiedPan === false ? (
          <div className="flex py-padding-sm px-padding-md gap-gap-sm rounded-b-border-radius-md bg-negative-card">
            <img
              src={ICONS?.ERROR_WITH_WHITE_OUTLINED_CIRCLE}
              alt="redcheck"
              className="h-icon-md w-icon-md mt-margin-xs"
            />
            <div className="flex flex-col gap-gap-xs">
              <div className="w-auto overflow-hidden text-ellipsis text-text-primary break-words whitespace-normal">
                PAN number is invalid
              </div>
              <div className="text-text-secondary text-left text-xs font-normal">
                Verification failed
              </div>
            </div>
          </div>
        ) : null}
      </div>
    </div>
  );
};

export default PanDetails;
